import { IPermissionSetGrouping, PermissionSetGroupingKey } from '../../PermissionSetTypes'
import { PermissionType } from '../../PermissionType'
import {
  AnalyticsTemplateLibraryPermissionSet,
  analyticsTemplateLibraryPermissionSetGrouping,
} from '../AnalyticsTemplateLibraryPermissions'
import {
  SuperAdminOrganizationPermissions,
  SuperAdminPermissions,
  SuperAdminToolPermissions,
} from './SuperAdminPermissions'

export enum DefaultSuperAdminPermissionSet {
  DefaultSuperAdmin = 'super_admin_default',
}

export const defaultSuperAdminPermissionSetGrouping: IPermissionSetGrouping<DefaultSuperAdminPermissionSet> = {
  key: PermissionSetGroupingKey.SuperAdminDefault,
  active: {
    [DefaultSuperAdminPermissionSet.DefaultSuperAdmin]: [
      ...SuperAdminToolPermissions,
      ...SuperAdminOrganizationPermissions.viewAny,
      ...SuperAdminOrganizationPermissions.manageOwn,
      ...SuperAdminOrganizationPermissions.createAny,
      ...SuperAdminPermissions.view,
      // allow super admins to view, write, archive, and delete analytics templates
      ...analyticsTemplateLibraryPermissionSetGrouping.active[AnalyticsTemplateLibraryPermissionSet.View],
      ...analyticsTemplateLibraryPermissionSetGrouping.active[AnalyticsTemplateLibraryPermissionSet.Write],
      ...analyticsTemplateLibraryPermissionSetGrouping.active[AnalyticsTemplateLibraryPermissionSet.Archive],
      ...analyticsTemplateLibraryPermissionSetGrouping.active[AnalyticsTemplateLibraryPermissionSet.Delete],
      // allow a super admin to call MTI organization endpoints until they are removed
      PermissionType.WRITE_ANY_MTI_ORGANIZATION,
      PermissionType.DELETE_ANY_MTI_ORGANIZATION,

      PermissionType.CAN_CREATE_ANY_UNMATCHED_REQUEST,
    ],
  },
  unAssignablePermissionSets: [DefaultSuperAdminPermissionSet.DefaultSuperAdmin],
  isSuperAdminSet: true,
}
